// extracted by mini-css-extract-plugin
export default {"text":"confidentiality_text__JpTBo","link":"confidentiality_link__8eB6i"};